import inicialState from './bloco.state';
import * as actions from './bloco.action';

const RC_blocoReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.MODAL_JUSTIFICATIVA:
      return {
        ...state,
        modalJustificativa: action.payload.modalJustificativa,
      };
    case actions.MODAL_CONFIRMAR:
      return {
        ...state,
        modalConfirmar: action.payload.modalConfirmar,
      };
    case actions.ATUALIZAR_BLOCO_ID:
      return {
        ...state,
        blocoId: action.payload.blocoId,
      };
    case actions.MODAL_BLOCO:
      return {
        ...state,
        modalBloco: action.payload.modalBloco,
      };

    case actions.ATUALIZAR_LISTAGEM_BLOCOS:
      return {
        ...state,
        listarBlocos: action.payload.listarBlocos,
      };

    case actions.CARREGAR_BLOCOS:
      return {
        ...state,
        carregarBlocos: action.payload.carregarBlocos,
      };
    case actions.ALTERAR_TEXT_BLOCO:
      return {
        ...state,
        blocoText: action.payload.blocoText,
      };

    default:
      return state;
  }
};

export default RC_blocoReducer;



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/bloco/bloco.reducer.js